module.exports = __webpack_public_path__ + "files/afeebb76a0201bf468f5e0b1a9622c09.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Math-Italic.woff2
// module id = 1189
// module chunks = 76